import * as S from "./AlertMessageBox.style";

interface AlertMessageBoxProps {
  icon?: React.ReactElement;
  text?: React.ReactElement;
  color: "colored" | "white";
  title?: string;
  children?: React.ReactElement | undefined;
}

export const AlertMessageBox = (props: AlertMessageBoxProps) => {
  return (
    <S.AlertMessageBox>
      <S.AlertMessageTitle $color={props.color}>
        {props.icon} {props.title}
      </S.AlertMessageTitle>
      <S.AlertMessageText $color={props.color}>{props.text}</S.AlertMessageText>

      {props.children && (
        <S.AlertMessageExtra>{props.children}</S.AlertMessageExtra>
      )}
    </S.AlertMessageBox>
  );
};
